import {
  Button,
  ButtonGroup,
  Card,
  Container,
  Form,
  FormControl,
  InputGroup,
  Spinner,
} from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import {
  get,
  getDatabase,
  ref,
  update,
} from 'firebase/database';
import * as storage from 'firebase/storage';
import { firebaseApp } from '../../../index';
import { useNavigate, useParams } from 'react-router-dom';
import { camelize } from '../../../Util';
import { assignCoupon, updateDeactivateSrikandiTag, getSrikandiEmas, useSrikandiUser } from '../../../API';
import { ISrikandiUser } from '../../../@types';
import { useAuth } from '../../../Context/AuthContext';
import DatePicker, { DateObject } from 'react-multi-date-picker';

const ROLES = [
  {
    id: 'admin',
    value: 'Admin',
  },
  {
    id: 'srikandi_emas',
    value: 'Srikandi Emas',
  },
  {
    id: 'srikandi',
    value: 'Srikandi',
  },
  {
    id: 'user',
    value: 'User',
  },
  {
    id: 'srikandi_emas_vip',
    value: 'Srikandi Platinum',
  },
  {
    id: 'deactivated',
    value: 'Deactivated',
  },
  {
    id: 'Terminated',
    value: 'Terminated',
  },
];

const PROFILES = [
  'full_name',
  'phone',
  'address',
  'state',
  'town',
  'country',
  'job',
  'eLHDNTin',
  'dropship_names',
  'dropship_sale',
  'reason',
  'facebook_url',
  'instagram_url',
  'dropship_facebook_url',
  'shopee_url',
  'is_customer',
  'ic_number',
  'telegram_username',
  'banking_account_number',
  'banking_account_name',
  'next_of_kin_phone',
  'next_of_kin_relationship',
];

const AGREEMENTS = ['full_name', 'email', 'ic_number', 'phone_number', 'address', 'signed_at'];

const SrikandiEdit = () => {
  const { userId } = useParams();
  const { dbUser } = useAuth();
  const user = useSrikandiUser(userId);
  const [orderId, setOrderId] = useState('');
  const [parentUsers, setParentUsers] = useState<ISrikandiUser[]>([]);
  const [parent, setParent] = useState<any>();
  const [busyFile, setBusyFetchingFiles] = useState<{ [path: string]: boolean }>({});
  const [file, setFile] = useState<{ [path: string]: any }>({});
  const [name, setName] = useState('');
  const [userProfile, setUserProfile] = useState<any>({});
  const [userAgreement, setUserAgreement] = useState<any>({});
  const [reportDate, setReportMonth] = useState(new Date());
  const navigate = useNavigate();

  const [role, setRole] = useState('');

  useEffect(() => {
    getSrikandiEmas().then(setParentUsers);
  }, []);

  useEffect(() => {
    if (user) {
      setName(user.name)
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      setUserProfile(user.profile);
    }
  }, [user?.profile]);

  useEffect(() => {
    if (user) {
      setUserAgreement(user.agreement);
    }
  }, [user?.agreement]);

  useEffect(() => {
    if (user?.starter_package?.order_id) {
      setOrderId(user.starter_package.order_id);
    }
  }, [user]);

  if (!user) {
    return (
      <Spinner
        animation="border"
        style={{
          position: 'absolute',
          height: '80px',
          width: '80px',
          top: '50%',
          left: '50%',
          marginLeft: '-50px',
          marginTop: '-30px',
        }}
      />
    );
  }

  const handleRoleSelect = (event: any) => {
    event.persist();
    setRole(event.target.value);
  };

  const handleGenerateCoupon = async () => {
    if (window.confirm('Confirm?')) {
      await assignCoupon(user.id);
      alert('Done');
    }
  };

  const handleCancel = () => {
    if (window.confirm('Are you sure you want to cancel?')) {
      navigate('/srikandi');
    }
  };

  const onViewFile = async (path: string) => {
    if (!path) {
      return;
    }
    if (file[path]) {
      console.log(path);
      console.log(file[path]);
      window.open(file[path]);
    } else {
      try {
        setBusyFetchingFiles((busy) => ({
          ...busy,
          [path]: true,
        }));
        const storageApp = storage.getStorage(firebaseApp);
        const storageRef = storage.ref(storageApp, path);
        const blob = await storage.getBlob(storageRef);
        const fileURL = URL.createObjectURL(blob);
        setFile((f) => ({
          ...f,
          [path]: fileURL,
        }));
        setBusyFetchingFiles((busy) => ({
          ...busy,
          [path]: false,
        }));
      } catch (err) {
        console.log(err);
        setBusyFetchingFiles((busy) => ({
          ...busy,
          [path]: false,
        }));
      }
    }
  };

  const handleParentChange = (event: any) => {
    event.persist();
    setParent(event.target.value);
  };

  const handleChangeOrderId = (event: any) => {
    event.persist();
    setOrderId(event.target.value);
  };

  const handleSubmit = async (event: any) => {
    event.persist();
    event.preventDefault();
    const updatedRole = role || user.role || null;
    const updatedParent = parent || user.parent || null;
    const updatedStarter_package = parent || user.starter_package || null;
    const database = getDatabase(firebaseApp);
    const userRef = ref(database, `users/${userId}`);
    const year = reportDate.getUTCFullYear();
    const month = reportDate.getUTCMonth() + 1; // Months are zero-based, so add 1
    const day = reportDate.getUTCDate();
    const dateString = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

    const updateVal = {
      name,
      role: updatedRole === 'null' ? null : updatedRole,
      parent: updatedParent === 'null' ? null : updatedParent,
      starter_package:
        `${user?.starter_package?.order_id}` !== orderId && orderId !== '' && orderId
          ? {
              order_id: orderId,
              ordered_at: new Date().toISOString(),
            }
          : user?.starter_package || null,
      profile: userProfile,
      agreement: userAgreement,
      // rankBonus: {
      //   amount: role || user.role === 'srikandi_emas' ? 100 : role || user.role === 'srikandi_emas_vip' ? 200 : 0,
      //   category: updatedRole,
      //   bonusDate: dateString
      // },
    };
    if (window.confirm('Are you sure you want to save?')) {
      await update(userRef, updateVal);
      if(updateVal.role === 'deactivated'){
        await updateDeactivateSrikandiTag(user.id);
      }
      alert('Done!');
    }
    console.log({updateVal})
  };

  const handleResetProfile = () => {
    if (window.confirm('Are you sure to clear profile?')) {
      setUserProfile({});
    }
  };

  const handleResetAgreement = () => {
    if (window.confirm('Are you sure to clear agreement?')) {
      setUserAgreement({});
    }
  };

  const isAdmin = dbUser?.role === 'admin';
  const isSelfProfile = dbUser?.id === user.id;
  const isEditable = isSelfProfile || isAdmin;

  const handleChangeName = (name: string) => {
    setName(name)
  }

  const handleChangeProfile = (value: string, key: string) => {
    setUserProfile((profile: any) => ({
      ...profile,
      [key]: value
    }))
  }

  return (
    <Container>
      <Form className="formMargin">
        <div className="sectionUserDetails">
          <h2 className="header">User Details</h2>
          <Form.Group className="mb-3 smallTitle">
            <Form.Label>Name</Form.Label>
            <Form.Control disabled={!isEditable} type="name" value={name} onChange={(event) => handleChangeName(event.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3 smallTitle">
            <Form.Label>Email</Form.Label>
            <Form.Control disabled type="email" value={user.email} />
          </Form.Group>
          <Form.Group className="mb-3 smallTitle">
            <Form.Label>Coupon</Form.Label>
            <InputGroup className="mb-3 smallTitle">
              <FormControl disabled value={user.coupon || ''} aria-describedby="basic-addon2" />
              {dbUser?.role === 'admin' ? (
                <Button onClick={handleGenerateCoupon} id="button-addon2" className="buttonCoupon">
                  Generate Coupon
                </Button>
              ) : null}
            </InputGroup>
          </Form.Group>
          <Form.Group className="mb-3 smallTitle">
            <Form.Label htmlFor="outletSelect">Role</Form.Label>
            <Form.Select
              disabled={dbUser?.role !== 'admin'}
              id="outletSelect"
              onChange={handleRoleSelect}
              value={role || user.role || 'null'}
              className="editSelectBox fullWidth"
            >
              <option value="null">No Role</option>
              {ROLES.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.value}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3 smallTitle">
            <Form.Label htmlFor="outletSelect">Srikandi Emas</Form.Label>
            <Form.Select
              disabled={dbUser?.role !== 'admin'}
              id="outletSelect"
              onChange={handleParentChange}
              value={parent || user.parent || 'null'}
              className="editSelectBox fullWidth"
            >
              <option value="null">No Parent</option>
              {parentUsers.map((e) => (
                <option key={e.id} value={e.id}>{`${e.name} (${e.email})`}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3 smallTitle">
            <Form.Label>Order ID</Form.Label>
            <Form.Control type="name" value={orderId} onChange={handleChangeOrderId} />
          </Form.Group>
        </div>
        <br></br>
        <h2 className="header">User Profile</h2>
        {PROFILES.map((key) => {
          // @ts-ignore
          const value = (userProfile || {})[key] || '';
          const editableFields = ['phone','state', 'town', 'address', 'banking_account_name', 'banking_account_number', 'ic_number', 'eLHDNTin']
          return (
            <Form.Group className="mb-3 smallTitle" key={key}>
              <Form.Label>{camelize(key)}</Form.Label> <small style={{ color: "red" }}>{key === 'eLHDNTin' && value === '' ? "Required" : null}</small>
              <Form.Control disabled={!(isEditable && editableFields.includes(key))} type="name" value={value} onChange={(event) => handleChangeProfile(event.target.value, key)} />
            </Form.Group>
          );
        })}
        {dbUser?.role === 'admin'
          ? (userProfile?.identification_path || '').split(':').map((path: string) => (
              <Form.Group className="mb-3 smallTitle" key={path}>
                <Form.Label>Identity Card File</Form.Label>
                <InputGroup className="mb-3 smallTitle">
                  <FormControl disabled value={path || ''} aria-describedby="basic-addon2" />
                  <Button
                    disabled={!path}
                    onClick={() => onViewFile(path)}
                    variant="outline-secondary"
                    id="button-addon3"
                    className="buttonCoupon"
                  >
                    {busyFile[path] ? (
                      <Spinner
                        animation="border"
                        style={{
                          position: 'absolute',
                          height: '80px',
                          width: '80px',
                          top: '50%',
                          left: '50%',
                          marginLeft: '-50px',
                          marginTop: '-30px',
                        }}
                      />
                    ) : file[path] ? (
                      'View File'
                    ) : (
                      'Fetch File'
                    )}
                  </Button>
                </InputGroup>
              </Form.Group>
            ))
          : null}

        {dbUser?.role === 'admin' ? (
          <div>
            <Button className="buttonReset" onClick={handleResetProfile}>
              Clear Profile
            </Button>
          </div>
        ) : null}
        <br></br>
        <br></br>
        <h2 className="header">Agreement Details</h2>
        {AGREEMENTS.map((key) => {
          // @ts-ignore
          const value = (userAgreement || {})[key] || '';
          return (
            <Form.Group className="mb-3 smallTitle" key={key}>
              <Form.Label>{camelize(key)}</Form.Label>
              <Form.Control
                disabled
                type="name"
                value={key === 'signed_at' && value ? new Date(value).toISOString() : value}
              />
            </Form.Group>
          );
        })}
        {/* agreement details */}
        {dbUser?.role === 'admin' ? (
          <Form.Group className="mb-3 smallTitle">
            <Form.Label>Agreement File</Form.Label>
            <InputGroup className="mb-3 smallTitle">
              <FormControl
                disabled
                value={userAgreement?.agreement_path || ''}
                aria-describedby="basic-addon2"
              />
              <Button
                disabled={!userAgreement?.agreement_path}
                onClick={() => onViewFile(userAgreement?.agreement_path || '')}
                variant="outline-secondary"
                id="button-addon2"
                className="buttonCoupon"
              >
                {busyFile[userAgreement?.agreement_path || ''] ? (
                  <Spinner
                    animation="border"
                    style={{
                      position: 'absolute',
                      height: '80px',
                      width: '80px',
                      top: '50%',
                      left: '50%',
                      marginLeft: '-50px',
                      marginTop: '-30px',
                    }}
                  />
                ) : file[userAgreement?.agreement_path || ''] ? (
                  'View PDF'
                ) : (
                  'Fetch PDF'
                )}
              </Button>
            </InputGroup>
            {dbUser?.role === 'admin' ? (
              <div>
                <Button className="buttonReset" onClick={handleResetAgreement} variant="light">
                  Clear Agreement
                </Button>
              </div>
            ) : null}
            <br></br>
          </Form.Group>
        ) : null}

        {/* <br></br>
        <br></br> */}
        {/* rank bonus */}
        {/* {dbUser?.role === 'admin' ? (
          <div>
            <h2 className="header">Rank Bonus</h2>
            <Card>
            <Card.Body>
              <Card.Text>
                <div className="row">
                  <Form.Group className="mb-3 smallTitle col">
                    <Form.Label>Email</Form.Label>
                    <Form.Control disabled type="email" value={user.email} />
                  </Form.Group>
                    <Form.Group className="mb-3 smallTitle col">
                      <Form.Label>Month</Form.Label><br></br>
                      <DatePicker
                        onlyMonthPicker
                        format="MMMM YYYY"
                        onChange={(data) => {
                          // @ts-ignore
                          if (data) {
                            const date = (data as DateObject).toDate();
                            date.setHours(24);
                            setReportMonth(date);
                          }
                        }}
                        value={reportDate}
                        minDate="2022/12/01"
                        style={{
                          border: '1px solid var(--primaryColor)',
                          height: '35px',
                          width: '280px',
                          textAlign: 'center',
                          fontSize: '1rem',
                        }}
                      />
                    </Form.Group>
                </div>
                
                <div className="row">
                  <Form.Group className="mb-3 smallTitle col">
                    <Form.Label htmlFor="outletSelect">Category</Form.Label>
                    <Form.Select
                      disabled
                      id="outletSelect"
                      onChange={handleRoleSelect}
                      value={role || user.role || 'null'}
                      className="editSelectBox fullWidth"
                    >
                      <option value="null">No Role</option>
                      {ROLES.map((e) => (
                        <option key={e.id} value={e.id}>
                          {e.value}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3 smallTitle col">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control disabled type="number" id='amount' value={role || user.role === 'srikandi_emas' ? 100 : role || user.role === 'srikandi_emas_vip' ? 200 : 0}/>
                    
                  </Form.Group>
                </div>
              </Card.Text>
            </Card.Body>
            </Card>
          </div>
        ) : null } */}

        {/* <br></br>
        <br></br> */}
        {/* bonus */}
        {/* {dbUser?.role === 'admin' ? (
          <div>
            <h2 className="header">Bonus</h2>
            <Card>
            <Card.Body>
              <Card.Text>
                <div className="row">
                  <Form.Group className="mb-3 smallTitle col">
                    <Form.Label>Email</Form.Label>
                    <Form.Control disabled type="email" value={user.email} />
                  </Form.Group>

                    <Form.Group className="mb-3 smallTitle col">
                      <Form.Label>Month</Form.Label><br></br>
                      <DatePicker
                        onlyMonthPicker
                        format="MMMM YYYY"
                        onChange={(data) => {
                          // @ts-ignore
                          if (data) {
                            const date = (data as DateObject).toDate();
                            date.setHours(24);
                            setReportMonth(date);
                          }
                        }}
                        value={reportDate}
                        minDate="2022/12/01"
                        style={{
                          border: '1px solid var(--primaryColor)',
                          height: '35px',
                          width: '280px',
                          textAlign: 'center',
                          fontSize: '1rem',
                        }}
                      />
                    </Form.Group>
                </div>

                <div className='row'>

                  <Form.Group className="mb-3 smallTitle col">
                    <Form.Label>Title Bonus</Form.Label>
                    <Form.Control type="text" id='titleBonus' onChange={e => setTitleBonus(e.target.value)}/>
                  </Form.Group>
                  <Form.Group className="mb-3 smallTitle col">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control type="number" id='amountExtraBonus' onChange={e => setExtraBonusAmount(e.target.value)}/>
                  </Form.Group>

                </div>
                
                <div className="row">
                </div>
              </Card.Text>
            </Card.Body>
            </Card>
          </div>
        ) : null } */}

        <div style={{ marginBottom: '100px' }}></div>
        {dbUser?.role === 'admin' ? (
          <ButtonGroup
            className="me-2"
            aria-label="Second group"
            style={{ position: 'fixed', right: '3%', bottom: '5%' }}
          >
            <Button
              onClick={handleCancel}
              style={{
                marginRight: '5px',
                color: 'var(--primaryColor)',
                backgroundColor: 'var(--secondaryColor)',
                border: '1px solid var(--secondaryColor)',
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              style={{
                color: 'var(--secondaryColor)',
                backgroundColor: 'var(--primaryColor)',
                border: '1px solid var(--primaryColor)',
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        ) : null}
      </Form>
    </Container>
  );
};

export default SrikandiEdit;
